export const asset = (relativePath) =>
  `${process.env.PUBLIC_URL || ""}/img/${relativePath}`;

export const PLAN_FALLBACK_URL = "/login";
export const WHATSAPP_NUMBER = "";

export const planCtaUrl = (plan) => {
  if (!WHATSAPP_NUMBER) return PLAN_FALLBACK_URL;
  const text = `Hola! Me interesa el plan ${plan || ""} de Voras.`.trim();
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};
